import React from "react";

export const patientsIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25.714"
		height="25.714"
		viewBox="0 0 25.714 25.714"
	>
		<g
			id="_1.-Doctor-Dashboard"
			data-name="1.-Doctor-Dashboard"
			transform="translate(-55.643 -157.643)"
		>
			<g id="Menu">
				<g id="Dashboard" transform="translate(55 157)">
					<path
						id="Rectangle"
						d="M10.286.643a1.929,1.929,0,0,1,1.929,1.929v4.5A1.929,1.929,0,0,1,10.286,9H2.571A1.929,1.929,0,0,1,.643,7.071v-4.5A1.929,1.929,0,0,1,2.571.643Zm0,1.286H2.571a.643.643,0,0,0-.632.527l-.01.116v4.5a.643.643,0,0,0,.527.632l.116.01h7.714a.643.643,0,0,0,.632-.527l.01-.116v-4.5a.643.643,0,0,0-.527-.632Z"
						fill="currentColor"
					/>
					<path
						id="Rectangle-Copy-5"
						d="M24.429,18a1.929,1.929,0,0,1,1.929,1.929v4.5a1.929,1.929,0,0,1-1.929,1.929H16.714a1.929,1.929,0,0,1-1.929-1.929v-4.5A1.929,1.929,0,0,1,16.714,18Zm0,1.286H16.714a.643.643,0,0,0-.632.527l-.01.116v4.5a.643.643,0,0,0,.527.632l.116.01h7.714a.643.643,0,0,0,.632-.527l.01-.116v-4.5a.643.643,0,0,0-.527-.632Z"
						fill="currentColor"
					/>
					<path
						id="Rectangle-Copy-3"
						d="M24.429.643a1.929,1.929,0,0,1,1.929,1.929V13.5a1.929,1.929,0,0,1-1.929,1.929H16.714A1.929,1.929,0,0,1,14.786,13.5V2.571A1.929,1.929,0,0,1,16.714.643Zm0,1.286H16.714a.643.643,0,0,0-.632.527l-.01.116V13.5a.643.643,0,0,0,.527.632l.116.01h7.714a.643.643,0,0,0,.632-.527l.01-.116V2.571a.643.643,0,0,0-.527-.632Z"
						fill="currentColor"
					/>
					<path
						id="Rectangle-Copy-4"
						d="M10.286,11.573A1.929,1.929,0,0,1,12.214,13.5V24.429a1.929,1.929,0,0,1-1.929,1.929H2.571A1.929,1.929,0,0,1,.643,24.429V13.5a1.929,1.929,0,0,1,1.929-1.929Zm0,1.286H2.571a.643.643,0,0,0-.632.527l-.01.116V24.429a.643.643,0,0,0,.527.632l.116.01h7.714a.643.643,0,0,0,.632-.527l.01-.116V13.5a.643.643,0,0,0-.527-.632Z"
						fill="currentColor"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export const usersIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24.609"
		height="28.421"
		viewBox="0 0 24.609 28.421"
	>
		<g id="Page-1" transform="translate(-0.196 -0.711)">
			<g
				id="_1.-Doctor-Dashboard"
				data-name="1.-Doctor-Dashboard"
				transform="translate(-56 -324)"
			>
				<g id="Menu">
					<g id="User" transform="translate(56 324)">
						<path
							id="Oval"
							d="M12.5.711A7.461,7.461,0,1,1,5.039,8.171,7.461,7.461,0,0,1,12.5.711Zm0,1.421a6.039,6.039,0,1,0,6.039,6.039A6.039,6.039,0,0,0,12.5,2.132Z"
							fill="currentColor"
						/>
						<path
							id="Rectangle"
							d="M12.5,17.337q10.992,0,12.293,10.194a1.421,1.421,0,0,1-1.41,1.6H1.617a1.421,1.421,0,0,1-1.41-1.6Q1.508,17.337,12.5,17.337Zm0,1.421c-6.486,0-9.956,2.761-10.829,8.561l-.055.39H23.383l-.054-.391C22.456,21.519,18.986,18.758,12.5,18.758Z"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export const invitationsIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="26.667"
		height="26.667"
		viewBox="0 0 26.667 26.667"
	>
		<g id="Page-1" transform="translate(-0.667 -0.667)">
			<g
				id="_1.-Doctor-Dashboard"
				data-name="1.-Doctor-Dashboard"
				transform="translate(-55 -241)"
			>
				<g id="Menu">
					<g id="Calendar" transform="translate(55 241)">
						<rect
							id="Rectangle"
							width="26.667"
							height="1.333"
							transform="translate(0.667 9.556)"
							fill="currentColor"
						/>
						<path
							id="Rectangle-2"
							data-name="Rectangle"
							d="M24.667,2.889a2.667,2.667,0,0,1,2.667,2.667V24.667a2.667,2.667,0,0,1-2.667,2.667H3.333A2.667,2.667,0,0,1,.667,24.667V5.556A2.667,2.667,0,0,1,3.333,2.889Zm0,1.333H3.333A1.334,1.334,0,0,0,2.009,5.4L2,5.556V24.667a1.334,1.334,0,0,0,1.178,1.324L3.333,26H24.667a1.334,1.334,0,0,0,1.324-1.178L26,24.667V5.556a1.334,1.334,0,0,0-1.178-1.324Z"
							fill="currentColor"
						/>
						<rect
							id="Rectangle-3"
							data-name="Rectangle"
							width="1.333"
							height="6.667"
							rx="0.5"
							transform="translate(6.155 0.667)"
							fill="currentColor"
						/>
						<rect
							id="Rectangle-Copy-3"
							width="1.333"
							height="6.667"
							rx="0.5"
							transform="translate(20.507 0.667)"
							fill="currentColor"
						/>
						<path
							id="Path-11-Copy"
							d="M20.195,13.317a.667.667,0,0,1,1.021.85l-.077.092-9.355,9.369a.667.667,0,0,1-.848.079l-.092-.076L6.865,19.7a.667.667,0,0,1,.845-1.025l.093.077,3.506,3.468Z"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export const signOutIcon = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25.688"
		height="25.03"
		viewBox="0 0 25.688 25.03"
	>
		<g id="Page-1" transform="translate(-0.643 -0.982)">
			<g
				id="_1.-Doctor-Dashboard"
				data-name="1.-Doctor-Dashboard"
				transform="translate(-55 -829)"
			>
				<g id="Menu">
					<g id="Logout" transform="translate(55 829)">
						<path
							id="Path-12-Copy"
							d="M20.919,7.1a.643.643,0,0,1,.82-.074l.089.074,4.314,4.32a.643.643,0,0,1,.074.82l-.074.089-4.314,4.32a.643.643,0,0,1-.984-.819l.074-.089,3.86-3.867-3.86-3.864a.643.643,0,0,1-.074-.82Z"
							fill="currentColor"
						/>
						<path
							id="Rectangle"
							d="M15.187,11.229H24.83a.643.643,0,1,1,0,1.286H15.187a.643.643,0,0,1,0-1.286Z"
							fill="currentColor"
						/>
						<path
							id="Rectangle-2"
							data-name="Rectangle"
							d="M1.929.989a1.286,1.286,0,0,1,.3.036l8.122,1.953a1.286,1.286,0,0,1,.985,1.25v20.5a1.286,1.286,0,0,1-1.586,1.25L1.628,24.023a1.286,1.286,0,0,1-.985-1.25V2.275A1.286,1.286,0,0,1,1.929.989Zm0,1.286v20.5l8.122,1.953V4.228Z"
							fill="currentColor"
						/>
						<path
							id="Path-13"
							d="M16.908,14.685a.643.643,0,0,1,.632.527l.01.116v4.85a2.686,2.686,0,0,1-1.059,2.347,2.412,2.412,0,0,1-1.163.42l-.178.008H10.7a.643.643,0,0,1-.116-1.275l.116-.01H15.15c.564,0,1.05-.312,1.109-1.286l.006-.2v-4.85A.643.643,0,0,1,16.908,14.685Z"
							fill="currentColor"
						/>
						<path
							id="Path-13-Copy"
							d="M16.908-.981a.643.643,0,0,0,.632-.527l.01-.116v-4.85a2.686,2.686,0,0,0-1.059-2.347,2.412,2.412,0,0,0-1.163-.42l-.178-.008H2.076a.643.643,0,0,0-.643.643.643.643,0,0,0,.527.632l.116.01H15.15c.564,0,1.05.312,1.109,1.286l.006.2v4.85A.643.643,0,0,0,16.908-.981Z"
							transform="translate(0 10.231)"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
